module.exports = __webpack_public_path__ + "img/chevy-Worth.6005b50f.png";